import sequences from "@/app/flows/sequences/index";
import botAIIntegration from "@/app/flows/botAIIntegration/index";
import FlowsPage from "@/app/flows/pages/FlowsPage.vue";
import FormsTemplate from "@/app/entities/components/templates/FormsTemplate.vue";
import CreateFormTemplate from "@/app/entities/components/templates/CreateFormTemplate.vue";
import Chatbots from "@/app/chatbots/views/Chatbots.vue";
import Chatbot from "@/app/chatbots/views/Chatbot.vue";
import EmailTemplatesPage from "@/app/flows/emailTemplates/pages/EmailTemplatesPage.vue";
import TemplatesListTemplate from "@/app/flows/emailTemplates/templates/TemplatesListTemplate.vue";
import TemplateDetailsTemplate from "@/app/flows/emailTemplates/templates/TemplateDetailsTemplate.vue";

export default [
  {
    path: "/flows",
    name: "flows",
    component: FlowsPage,
    redirect: "/flows/forms",
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "forms",
        component: FormsTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "forms/:id",
        component: CreateFormTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "chatbots",
        component: Chatbots,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "chatbots/tree/:id",
        component: Chatbot,
        meta: {
          requiresAuth: true,
          transparent: true,
        },
      },
      ...sequences.routes,
      {
        path: "templates-email",
        component: EmailTemplatesPage,
        meta: {
          requiresAuth: true,
        },
        children: [
          {
            path: "",
            component: TemplatesListTemplate,
            meta: {
              requiresAuth: true,
            },
          },
          {
            path: ":id",
            component: TemplateDetailsTemplate,
            meta: {
              requiresAuth: true,
            },
          },
        ],
      },
      ...botAIIntegration.routes,
    ],
  },
];
